import { Col, Row, Table } from "react-bootstrap";
import logo from "../../assets/logo.png";
import "./index.scss";
import { useEffect, useState } from "react";
import api from "../../Components/Api/Api3";
import apiTx from "../../Components/Api/Api";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Spinner from "../../Components/Spinner";
import "swiper/css/bundle";
import { useSearchParams } from "react-router-dom";
const PainelSalaVip = () => {
  const [filial, setFilial] = useState<any>("");
  const [searchParams] = useSearchParams();
  const [ready, setReady] = useState(false);
  const [atualizar, setAtualizar] = useState(false);
  const [ShowLoading, setShowLoading] = useState(false);
  const [orcamentos, setOrcamentos] = useState([]);
  const [refresh, setRefresh] = useState(3600);
  let timeout: NodeJS.Timeout;
  const COUNTDOWN_AMOUNT_TOTAL = 2 * 60; // 2 MINUTOS
  const [seconds, setSeconds] = useState<number>(COUNTDOWN_AMOUNT_TOTAL);
  const credentials = btoa("RestAPI:siga@181");
  const headers = {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    "User-Agent": "PneusBrasil",
    Accept: "application/json",
    Authorization: `Basic ${credentials}`,
  };
  const isFilial01 = (valor?: any) => {
    const filialInformada = String(valor ?? filial ?? "").trim();
    return filialInformada === "01" || filialInformada === "1";
  };
  const getApiPorFilial = (valor?: any) => (isFilial01(valor) ? apiTx : api);
  function getentradas(cFilial: any) {
    const filialValida = String(cFilial ?? "").trim();
    if (!filialValida) {
      setShowLoading(false);
      setAtualizar(true);
      return;
    }

    setTimeout(() => {
      setShowLoading(true);
      getApiPorFilial(filialValida)
        .get("Painelvip?filial=" + filialValida + "&top=18", { headers })
        .then((response) => {
          if (response.data.Entradas.length > 0) {
            setOrcamentos(response.data.Entradas);
            setAtualizar(true);
            setShowLoading(false);
            //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])
          } else {
            //setInfoveuculo('Placa não cadastrada!')
            setShowLoading(false);
            setAtualizar(true);
          }
        })
        .catch((error) => {
          console.error("Erro ao carregar Painel VIP:", error);
          setOrcamentos([]);
          setShowLoading(false);
          setAtualizar(true);
        });
    }, 10);
  }
  // const entrar = () => {
  //     if(pin === gpin){
  //         setShowpainel(true);
  //         setShowpin(true)
  //     }else{
  //         alert('Pin invalido!')
  //     }
  // }
  useEffect(() => {
    if (!ready) {
      setFilial(searchParams.get("filial"));
      //console.log("filial: "+ searchParams.get('filial'))
      getentradas(searchParams.get("filial"));
      setReady(true);
      //getPin('01')
    }
    if (!atualizar && ready) {
      //console.log("filial: segunda vez "+ filial)
      getentradas(filial);
    }
    if (seconds > 0) {
      timeout = setTimeout(() => {
        setSeconds((state) => state - 1);
      }, 1000);
    } else {
      clearTimeout(timeout);
      setSeconds(COUNTDOWN_AMOUNT_TOTAL);
      setAtualizar(false);
    }
    // const painel = document.querySelectorAll("div[id=divpainel]");
    // if (showpainel === true){
    //     painel[0].setAttribute('style', 'display:block');
    // }else{
    //     painel[0].setAttribute('style', 'display:none');
    // }
    // const pin = document.querySelectorAll("div[id=divpin]");
    // if (showpin === false){
    //     pin[0].setAttribute('style', 'display:block');
    // }else{
    //     pin[0].setAttribute('style', 'display:none');
    // }
  }, [seconds]);
  return (
    <>
      <Row className="flex-collum1">
        <Col className="w-25 d-flex justify-content-center">
          <img src={logo} className="logo" alt="Car Center Pneus Brasil" />
        </Col>
        <Col className="w-75 d-flex justify-content-center coll1-descri">
          <span className="fs-1 text-white font-weight-bold">
            Painel de serviços
          </span>
        </Col>
      </Row>
      <Row className=".Row-geral">
        <Col className="flex-collum2 col-6">
          <Table
            striped
            bordered
            hover
            variant="light"
            responsive
            className="scrol"
          >
            <thead>
              <tr className="col-title">
                <th>Placa</th>
                <th>Modelo</th>
                <th>Cor</th>
                <th>Status</th>
                <th>Finalizado</th>
              </tr>
            </thead>
            <tbody className="">
              {orcamentos.map((list: any) => (
                <tr key={list.id}>
                  <td>{list.placa}</td>
                  <td>{list.modelo}</td>
                  <td>{list.cor}</td>
                  {list.Status === "Ordem Finalizada" ? (
                    <td className={"text-success"}>{list.Status}</td>
                  ) : (
                    <td className={"text-primary"}>{list.Status}</td>
                  )}
                  {list.Status === "Ordem Finalizada" ? (
                    <td className={"text-success"}>SIM</td>
                  ) : (
                    <td className={"text-danger"}>NAO</td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
          <Spinner isLoading={ShowLoading} />
        </Col>
        <Col className="flex-collum3 col-6">
          <Swiper
            slidesPerView={1}
            autoplay={{
              delay: 10000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            spaceBetween={0}
            //slidesPerView={1}
            //autoplay={true}
            loop
            speed={5000}
            className="margens"
            //onSlideChange={() => console.log('slide change')}
            //onSwiper={(swiper: any) => console.log(swiper)}
          >
            <SwiperSlide>
              <img
                className="imagensbanner"
                src="https://carcenterpneusbrasil.com/banner/1.png"
                alt="Primeiro Slide"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                className="imagensbanner"
                src="https://carcenterpneusbrasil.com/banner/2.png"
                alt="Segundo Slide"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                className="imagensbanner"
                src="https://carcenterpneusbrasil.com/banner/3.png"
                alt="Terceiro Slide"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                className="imagensbanner"
                src="https://carcenterpneusbrasil.com/banner/4.png"
                alt="Terceiro Slide"
              />
            </SwiperSlide>
          </Swiper>
        </Col>
      </Row>
      <div className="foot">
        <span>{seconds}</span>
      </div>
    </>
  );
};

export default PainelSalaVip;
